export const fdefUploadBenutzer = {
  formdefinition: [
    {
      control: "autocomplete",
      name: "kunde_id_ov",
      label: "Kunde",
      valid: "isNotEmpty(item)",
      cols: "12",
      get_api: {
        target: "options",
        method: "get",
        endpoint: "data/kundes_select",
      },
    },
    {
      control: "upload",
      name: "benutzer",
      label: "Benutzer",
      allowedExtensions: ["XLSX"],
      cols: "12",
      valid: "isNotEmpty(item)",
    },
  ],
  transformOut: [],
};
